import { render, staticRenderFns } from "./MaterialTeaser.vue?vue&type=template&id=6a4923a0&scoped=true&"
import script from "./MaterialTeaser.vue?vue&type=script&lang=js&"
export * from "./MaterialTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4923a0",
  null
  
)

export default component.exports